import { createReducer } from 'store/createReducer';
import { ICart } from 'models/ICart';
import { LoadingStatus } from 'models/LoadingStatus';
import {
  CART_LOADED,
  CART_LOADER,
  CART_PRODUCT_ADD,
  CART_PRODUCT_REMOVE,
  CART_QUANTITY_UPDATE,
  CART_RENTALPERIOD_UPDATE,
  CartAction,
  CartStatusAction,
  CartQuantityUpdateAction,
  CartModalData,
  CART_MODAL_SHOW,
  CartModalAction,
  CART_MODAL_CLOSE,
  CartRentalPeriodUpdateAction,
  CART_CHARGES,
  CartSummaryAction,
  CART_ORIGIN_UPDATE,
  CartOriginUpdateAction
} from './actions';
import { CLEAR_EXPIRED_PRODUCTS } from 'components/ExpiredProducts/actions';
import { CHECKOUT_PURCHASE_RESPONSE, PurchaseResponseAction } from 'views/CheckoutPage/actions';
import { ICharge } from 'models/ICharge';
import { Charge } from 'models/Charge';
import { UpdateCurrentPageAction, UPDATE_CURRENT_PAGE } from 'components/Pagelayout/actions';
import { isCheckoutPage } from 'models/CheckoutPageModel';

const reducer = {
  [CART_LOADER]: (state: ICart, { status }: CartStatusAction) => {
    return { ...state, status };
  },

  [CART_LOADED]: (state: ICart, { cart }: CartAction) => {
    return { ...state, ...cart };
  },
  [CART_PRODUCT_ADD]: (state: ICart) => {
    return state;
  },
  [CART_PRODUCT_REMOVE]: (state: ICart) => {
    return state;
  },
  [CART_QUANTITY_UPDATE]: (state: ICart, { cartItemId, amount }: CartQuantityUpdateAction) => {
    return {
      ...state,
      cartItems: state.cartItems.map(item =>
        item.cartItemId !== cartItemId ? item : { ...item, quantity: { ...item.quantity, amount } }
      )
    };
  },
  [CART_RENTALPERIOD_UPDATE]: (state: ICart, { cartItemId }: CartRentalPeriodUpdateAction) => {
    return {
      ...state,
      cartItems: state.cartItems.map(item =>
        item.cartItemId !== cartItemId
          ? item
          : { ...item, rentalPeriod: { ...item.rentalPeriod, returnDate: null } }
      )
    };
  },
  [CART_MODAL_SHOW]: (state: CartState, { title, messages }: CartModalAction) => {
    return {
      ...state,
      error: { title, messages }
    };
  },
  [CART_MODAL_CLOSE]: (state: CartState) => {
    return {
      ...state,
      error: undefined
    };
  },
  [CLEAR_EXPIRED_PRODUCTS]: (state: CartState) => {
    return {
      ...state,
      expiredInWebShopProducts: []
    };
  },
  [CHECKOUT_PURCHASE_RESPONSE]: (state: CartState, { response }: PurchaseResponseAction) => {
    return {
      ...state,
      expiredInWebShopProducts: response.expiredInWebShopProducts || state.expiredInWebShopProducts
    };
  },
  [CART_CHARGES]: (state: CartState, { summary }: CartSummaryAction) => {
    if (!summary || !summary.charges) {
      return state;
    }

    const charges = summary.charges.filter(isCharge);

    return {
      ...state,
      cartCharges: charges
    };
  },
  [CART_ORIGIN_UPDATE]: (
    state: CartState,
    { salesOriginId, salesOriginClassId }: CartOriginUpdateAction
  ) => {
    return { ...state, salesOriginId, salesOriginClassId };
  },
  [UPDATE_CURRENT_PAGE]: (state: CartState, { newPage }: UpdateCurrentPageAction) => {
    if (!isCheckoutPage(newPage) || !newPage.cart) {
      return state;
    }
    return { ...state, ...newPage.cart };
  }
};

const isCharge = (charge: ICharge): charge is Charge => {
  return !!(charge as Charge).productId;
};

export function isErrorSet(cart: ICart): cart is CartState {
  return (cart as CartState).error !== undefined;
}
export interface CartState extends ICart {
  error?: CartModalData;
}
export const initialState: CartState = {
  cartId: '',
  cartItems: [],
  vouchers: [],
  totalDiscountAmount: 0,
  totalDiscountPercentString: '',
  totalLineAmount: 0,
  totalLineAmountIncludingCharges: 0,
  originalTotalPrice: 0,
  lowestPartPaymentAmount: 0,
  status: LoadingStatus.Completed,
  subItemRelations: {},
  discountCode: '',
  hasRotDeduction: false,
  cartCharges: [],
  expiredInWebShopProducts: [],
  totalTaxAmount: 0,
  cartUrl: '',
  hasRentalProducts: false,
  needsCertificateId: false,
  bobSubItemRelations: [],
  adminCartCharges: [],
  salesOriginClassId: '',
  salesOriginId: '',
  shouldHideDiscountField: false,
  deliverySessionId: '',
  fulfilledInSystem: 1
};

export default createReducer(initialState, reducer);
